<template>
  <div class="backHomeWrap">
    <a href="javascript:;" class="backHome" @click="goHome">
      <i class="iconfont iconhome"></i>
      {{shopName}}
    </a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  mounted () {
    console.log(this.shopName)
  },
  computed: {
    ...mapGetters(['shopName'])
  },
  methods: {
    goHome () {
      if (this.$route.path.indexOf('index') == -1) {
        this.$router.push('index')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.backHomeWrap{
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 9999;
  .backHome{
    font-size: 20px;
    color: $base-theme;
    .iconfont{
      font-size: 24px;
    }
  }
}
</style>
